import styled from 'styled-components'
import { ClinTheme } from '../../../../ClinTheme'

interface IStorageProps {
  backgroundColor: string
}

export const StorageLabel = styled.div<IStorageProps>(
  {
    display: 'flex',
    width: 'fit-content',
    justifyContent: 'center',
    padding: '5px 10px',
    borderRadius: ClinTheme.space[2]
  },
  ({ backgroundColor }: IStorageProps) => ({
    backgroundColor: backgroundColor
  })
)

export const StyledStorageContainer = styled.span({
  position: 'relative'
})
